import styled from 'styled-components';
import Icon from 'components/Icon';
import {commonPalette} from 'styles/palette';

export const Description = styled.p`
  font-size: 18px;
  font-family: 'Lato';
  color: #333;
  padding-bottom: 16px;
  font-size: 14px;
`;

export const SaveButton = styled.button`
  background-color: ${commonPalette.surfaceBrand};
  opacity: ${({disabled}) => (disabled ? 0.5 : 1)};
  border: none;
  color: #fff;
  font-size: 16px;
  padding: 15px;
  border-radius: 3px;
  letter-spacing: 1px;
  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
  text-transform: uppercase;
`;

export const CloseIcon = styled(Icon)`
  height: 16px;
  margin-top: 5px;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const MediaUploaderWrapper = styled.div`
  margin-top: 21px;
  flex: 1;
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  flex-direction: row;
  gap: 16px;
`;

export const Label = styled.p`
  font-size: 16px;
  font-family: 'Lato';
  color: #686e6e;
  padding-bottom: 8px;
`;
